import React from "react";
import Carousel from "react-bootstrap/Carousel";
import StarIcon from "@material-ui/icons/Star";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";

function RelatedproductSlider() {
  return (
    <>
      <Carousel>
        <Carousel.Item interval={2000}>
          <div className="row">
            <div className="col-4 p-md-4">
              <div className="product-wap card rounded-0">
                <div className="card rounded-0">
                  <img
                    className="card-img rounded-0 img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="itsimage"
                  />
                  <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                    <ul className="list-unstyled">
                      <li>
                        <a
                          className="btn btn-success text-white"
                          href="shop-single.html"
                        >
                         <FavoriteBorderIcon />
                        </a>
                      </li>
                      <li>
                        <a
                          className="btn btn-success text-white mt-2"
                          href="shop-single.html"
                        >
                         <VisibilityIcon />
                        </a>
                      </li>
                      <li>
                        <a
                          className="btn btn-success text-white mt-2"
                          href="shop-single.html"
                        >
                          <AddShoppingCartIcon />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  <a
                    href="shop-single.html"
                    className="h3 text-decoration-none"
                  >
                    White Shirt
                  </a>
                  <ul className="w-100 list-unstyled d-flex justify-content-between mb-0">
                    <li>M/L/X/XL</li>
                    <li className="pt-2">
                      <span className="product-color-dot color-dot-red float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-blue float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-black float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-light float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-green float-left rounded-circle ml-1"></span>
                    </li>
                  </ul>
                  <ul className="list-unstyled d-flex justify-content-center mb-1">
                    <li>
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-muted" />
                      <StarIcon className="text-muted" />
                    </li>
                  </ul>
                  <p className="text-center mb-0">$25.00</p>
                </div>
              </div>
            </div>
            <div className="col-4 p-md-4">
              <div className="product-wap card rounded-0">
                <div className="card rounded-0">
                  <img
                    className="card-img rounded-0 img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="itsimage"
                  />
                  <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                    <ul className="list-unstyled">
                      <li>
                        <a
                          className="btn btn-success text-white"
                          href="shop-single.html"
                        >
                         <FavoriteBorderIcon />
                        </a>
                      </li>
                      <li>
                        <a
                          className="btn btn-success text-white mt-2"
                          href="shop-single.html"
                        >
                         <VisibilityIcon />
                        </a>
                      </li>
                      <li>
                        <a
                          className="btn btn-success text-white mt-2"
                          href="shop-single.html"
                        >
                          <AddShoppingCartIcon />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  <a
                    href="shop-single.html"
                    className="h3 text-decoration-none"
                  >
                    White Shirt
                  </a>
                  <ul className="w-100 list-unstyled d-flex justify-content-between mb-0">
                    <li>M/L/X/XL</li>
                    <li className="pt-2">
                      <span className="product-color-dot color-dot-red float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-blue float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-black float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-light float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-green float-left rounded-circle ml-1"></span>
                    </li>
                  </ul>
                  <ul className="list-unstyled d-flex justify-content-center mb-1">
                    <li>
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-muted" />
                      <StarIcon className="text-muted" />
                    </li>
                  </ul>
                  <p className="text-center mb-0">$25.00</p>
                </div>
              </div>
            </div>
              <div className="col-4 p-md-4">
              <div className="product-wap card rounded-0">
                <div className="card rounded-0">
                  <img
                    className="card-img rounded-0 img-fluid"
                    src={
                      "https://res.cloudinary.com/talhakash/image/upload/v1618827553/slmjl6v8sjgfqzqqopyr.jpg"
                    }
                    alt="itsimage"
                  />
                  <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                    <ul className="list-unstyled">
                      <li>
                        <a
                          className="btn btn-success text-white"
                          href="shop-single.html"
                        >
                         <FavoriteBorderIcon />
                        </a>
                      </li>
                      <li>
                        <a
                          className="btn btn-success text-white mt-2"
                          href="shop-single.html"
                        >
                         <VisibilityIcon />
                        </a>
                      </li>
                      <li>
                        <a
                          className="btn btn-success text-white mt-2"
                          href="shop-single.html"
                        >
                          <AddShoppingCartIcon />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  <a
                    href="shop-single.html"
                    className="h3 text-decoration-none"
                  >
                    White Shirt
                  </a>
                  <ul className="w-100 list-unstyled d-flex justify-content-between mb-0">
                    <li>M/L/X/XL</li>
                    <li className="pt-2">
                      <span className="product-color-dot color-dot-red float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-blue float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-black float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-light float-left rounded-circle ml-1"></span>
                      <span className="product-color-dot color-dot-green float-left rounded-circle ml-1"></span>
                    </li>
                  </ul>
                  <ul className="list-unstyled d-flex justify-content-center mb-1">
                    <li>
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-warning" />
                      <StarIcon className="text-muted" />
                      <StarIcon className="text-muted" />
                    </li>
                  </ul>
                  <p className="text-center mb-0">$25.00</p>
                </div>
              </div>
            </div>
          </div>
        </Carousel.Item>
        
      </Carousel>
    </>
  );
}

export default RelatedproductSlider;
